module.exports = __webpack_public_path__ + "img/nexus-logo.58fdcb0e.png";